export default __webpack_public_path__ + "static/media/video_icon.7de1d8b4.svg";